import React, { useState } from 'react';
import { Alert, Button, Checkbox, Col, Form, Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

type Props = {
  onDone: () => void,
  submitData: (data: Object) => void,
};

const LeadPageSubscribeForm = ({ onDone, submitData }: Props) => {
  const [busy, setBusy] = useState(false);
  const [indeterminate, setIndeterminate] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(false);
  const [showErrorMessage, setShowErrorMessage] = React.useState(false);
  const [form] = Form.useForm();

  const onFinish = (values) => {
    if (!values.sub_email && !values.sub_text_msg && !values.sub_phone) {
      setShowErrorMessage(true);
      return;
    }
    const transformedValues = {
      sub_email: values.sub_email ? 1 : 0,
      sub_text_msg: values.sub_text_msg ? 1 : 0,
      sub_phone: values.sub_phone ? 1 : 0,
      subscribe:
        values.sub_email || values.sub_text_msg || values.sub_phone
          ? 'Yes'
          : 'No',
    };
    setBusy(true);
    submitData(transformedValues)
      .then(function (res) {
        if (res.data.result === 'Success') {
          onDone();
        }
      })
      .finally(() => setBusy(false));
  };

  const onCheckAllChange = (e) => {
    const checked = e.target.checked;
    setIndeterminate(false);
    if (checked) {
      form.setFieldsValue({
        sub_email: true,
        sub_text_msg: true,
        sub_phone: true,
      });
    } else {
      form.setFieldsValue({
        sub_email: false,
        sub_text_msg: false,
        sub_phone: false,
      });
    }
  };

  const onCheckItemChange = () => {
    const values = form.getFieldsValue();
    if (values.sub_email && values.sub_text_msg && values.sub_phone) {
      setCheckAll(true);
      setIndeterminate(false);
    } else {
      setCheckAll(false);
      if (values.sub_email || values.sub_text_msg || values.sub_phone) {
        setIndeterminate(true);
      } else {
        setIndeterminate(false);
      }
    }
  };

  return (
    <Form
      className="lead-page-form opacity-95 lg:opacity-100 transition-opacity"
      onFinish={onFinish}
      form={form}
      initialValues={{
        subscribe: false,
        sub_email: false,
        sub_text_msg: false,
        sub_phone: false,
      }}
    >
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        spinning={busy}
      >
        <h3 className="text-center font-bold">
          Your request has been registered!
        </h3>
        <p className="text-center mb-6">
          Our car experts will be in touch within the next business day to
          assist you! Feel free to reach us at{' '}
          <a href="tel: 65335878">6533 5878</a> if you need further assistance.
          We will be glad to help!
        </p>
        <h4 className="os-text-19 font-bold text-center mb-6">
          Get up to date with our latest promotions{' '}
          <br className="hidden md:block" />
          and car reviews!
        </h4>
        <Form.Item valuePropName="checked">
          <Checkbox
            indeterminate={indeterminate}
            onChange={onCheckAllChange}
            value={checkAll}
          >
            Yes! I would love to receive updates about promotions, products
            &amp; services, news &amp; events from Carousell and/or its partners
            through the following modes of communication:
          </Checkbox>
        </Form.Item>

        <Row>
          <Col xs={{ span: 8 }} className="text-center">
            <Form.Item name="sub_email" valuePropName="checked">
              <Checkbox onChange={onCheckItemChange}>Email</Checkbox>
            </Form.Item>
          </Col>
          <Col xs={{ span: 8 }} className="text-center">
            <Form.Item name="sub_text_msg" valuePropName="checked">
              <Checkbox onChange={onCheckItemChange}>SMS</Checkbox>
            </Form.Item>
          </Col>
          <Col xs={{ span: 8 }} className="text-center">
            <Form.Item name="sub_phone" valuePropName="checked">
              <Checkbox onChange={onCheckItemChange}>Call</Checkbox>
            </Form.Item>
          </Col>
          {showErrorMessage ? (
            <Col span={24} className="mb-6">
              <Alert
                message="Please check 1 to receive updates for carousell promos."
                type="warning"
              />
            </Col>
          ) : null}
        </Row>
        <Row gutter={30}>
          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              className="get-quote-button"
              size="large"
            >
              Subscribe
            </Button>
          </Col>
          <Col span={12}>
            <Button
              htmlType="button"
              className="w-full"
              size="large"
              onClick={onDone}
            >
              No, thanks.
            </Button>
          </Col>
        </Row>
      </Spin>
    </Form>
  );
};

export default LeadPageSubscribeForm;
